export const questionContent = {
  title: (number) => `Question ${number}`,
  anwered: {
    selected: "Selected answer",
    correct: "Correct answer",
  },
};
